import { Instance, types as t } from 'mst-effect';
import { CancelablePromise } from 'cancelable-promise';
import { withFetchAllPages } from 'utils/requestHelpers/withFetchAllPages';
import { withRunInAction } from 'utils/withRunInAction';

export enum ModeEnum {
  ANNOTATE = 'Annotate',
  PREDICT = 'Predict',
}

export enum ZoomTextEnum {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

const zoomTextLevels = [ZoomTextEnum.XS, ZoomTextEnum.S, ZoomTextEnum.M, ZoomTextEnum.L, ZoomTextEnum.XL];

const settingsModel = t.model({
  show: t.boolean,
});

export const InputsViewerStore = t
  .compose(
    withRunInAction(),
    t.model('InputsViewerStore', {
      mode: t.optional(t.enumeration<ModeEnum>([ModeEnum.ANNOTATE, ModeEnum.PREDICT]), ModeEnum.ANNOTATE),
      settings: t.optional(settingsModel, { show: false }),
      visibleTabs: t.optional(
        t.model({
          bbox: t.boolean,
          poly: t.boolean,
          tags: t.boolean,
        }),
        {
          bbox: true,
          poly: true,
          tags: true,
        },
      ),
      visibleSections: t.optional(
        t.model({
          annotations: t.boolean,
          predictions: t.boolean,
        }),
        {
          annotations: true,
          predictions: true,
        },
      ),
      zoomTextLevel: t.optional(t.enumeration<ZoomTextEnum>(zoomTextLevels), ZoomTextEnum.M),
      modelId: t.maybe(t.string),
      autocompletePromise: t.optional(t.frozen<CancelablePromise>(), new CancelablePromise(() => {})),
      predictionEntity: t.maybeNull(t.frozen<{ type: 'workflow' | 'model'; data: CF.API.Workflows.Workflow | CF.API.Models.Model }>()),
      predictionEntityVersion: t.maybe(t.frozen<{ idx: number; versionId: string }>()),
      predictionEntityDeploymentId: t.maybe(t.string),
    }),
    withFetchAllPages(),
  )
  .actions((self) => ({
    setMode(mode: ModeEnum): void {
      self.mode = mode;
    },
    setSettings(payload: Instance<typeof settingsModel>): void {
      self.settings = payload;
    },
    setZoomTextLevel(zoomTextLevel: ZoomTextEnum): void {
      self.zoomTextLevel = zoomTextLevel;
    },
    setZoomForText(zoomIn: boolean): void {
      const currentZoomTextLevel = zoomTextLevels.indexOf(self.zoomTextLevel);

      if (zoomIn) {
        // If user tries to Zoom IN and current zoom level is not the last one
        if (currentZoomTextLevel < zoomTextLevels.length - 1) self.zoomTextLevel = zoomTextLevels[currentZoomTextLevel + 1];
      } else if (currentZoomTextLevel > 0) {
        // If user tries to Zoom OUT and current zoom level is not the first one
        self.zoomTextLevel = zoomTextLevels[currentZoomTextLevel - 1];
      }
    },
  }));
